import React, { useCallback, useEffect, useState } from 'react';

import cx from 'classnames';

import styleRegister from './Register.module.css';
import { CompletedRegistrationStep } from './Step/CompletedRegistrationStep/CompletedRegistrationStep';
import { Step } from './Step/Step';
import { StepFour } from './Step/StepFour/StepFour';
import { StepOne } from './Step/StepOne/StepOne';
import { StepThree } from './Step/StepThree/StepThree';
import { StepTwo } from './Step/StepTwo/StepTwo';
import { StepIndicators } from './StepIndicators/StepIndicators';
import s from '../Authorization.module.css';
import { BackStep } from '../BackStep/BackStep';
import { Header } from '../Header/Header';
import { useRegistration } from '../hooks';

export const Register = () => {
    const {
        state,
        updateEmail,
        updateName,
        updatePassword,
        updateAcceptEULA,
        updatePhone,
        updatePhoneConfirmed,
        step,
        sendValidateFirstStepRequest,
        updateActivity,
        updateCity,
        updateCountry,
        sendValidateFourthStepRequest,
        sendPhoneForSendOneTimeCode,
        sendConfirmationCode,
        updateCode,
        serverErrors,
        setServerErrors,
        stepBack,
        token,
        setToken,
        setStep,
    } = useRegistration();

    const [activitiesList, setActivitiesList] = useState(null);
    const [cityList, setCityList] = useState(null);
    const getFieldActivityList = useCallback(() => {
        const url = helpable.replaceUrlParameters(routable.getRoute('getFieldActivityList'));

        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                setActivitiesList(data.response.field_activities);
            })
            .catch(() => {
                // TODO use catch
            });
    }, []);
    const getCityList = useCallback(() => {
        const url = helpable.replaceUrlParameters(routable.getRoute('getCityList'));

        fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json;charset=utf-8',
            },
        })
            .then((response) => response.json())
            .then((data) => {
                setCityList(data.response.cities);
            })
            .catch(() => {
                // TODO use catch
            });
    }, []);

    useEffect(() => {
        getFieldActivityList();
        getCityList();
    }, [getCityList, getFieldActivityList]);

    return (
        <div className={s.authorizationBlock}>
            <Header
                type="mobile"
                link={<BackStep step={step} stepBack={stepBack} />}
                needShowBack
            />
            <div className={s.content}>
                <div className={cx(s.mainImage, { [styleRegister.notShowBlock]: step === 4 })} />
                <div className={cx(s.formWrapper, s.registerFormWrapper)}>
                    <div className={s.registerWrapper}>
                        <Header
                            type="desktop"
                            link={<BackStep step={step} stepBack={stepBack} />}
                            needShowBack
                        />
                        <Step>
                            {step === 0 && (
                                <StepOne
                                    state={state}
                                    updateEmail={updateEmail}
                                    updateName={updateName}
                                    updatePassword={updatePassword}
                                    updateAcceptEULA={updateAcceptEULA}
                                    sendValidateFirstStepRequest={sendValidateFirstStepRequest}
                                    serverErrors={serverErrors}
                                    setServerErrors={setServerErrors}
                                />
                            )}
                            {step === 1 && (
                                <StepTwo
                                    state={state}
                                    updatePhone={updatePhone}
                                    sendPhoneForSendOneTimeCode={sendPhoneForSendOneTimeCode}
                                    token={token}
                                    setToken={setToken}
                                />
                            )}
                            {step === 2 && (
                                <StepThree
                                    state={state}
                                    updatePhoneConfirmed={updatePhoneConfirmed}
                                    sendConfirmationCode={sendConfirmationCode}
                                    updateCode={updateCode}
                                    serverErrors={serverErrors}
                                    setServerErrors={setServerErrors}
                                    sendPhoneForSendOneTimeCode={sendPhoneForSendOneTimeCode}
                                    setToken={setToken}
                                    setStep={setStep}
                                />
                            )}
                            {step === 3 && activitiesList && cityList && (
                                <StepFour
                                    state={state}
                                    updateActivity={updateActivity}
                                    updateCity={updateCity}
                                    updateCountry={updateCountry}
                                    sendValidateFourthStepRequest={sendValidateFourthStepRequest}
                                    activitiesList={activitiesList}
                                    cityList={cityList}
                                />
                            )}
                            {step === 4 && (
                                <CompletedRegistrationStep redirectUrl={state.redirectUrl} />
                            )}
                        </Step>
                        <div className={s.stepBackMobile}>
                            <BackStep step={step} stepBack={stepBack} />
                        </div>
                    </div>
                    {step !== 4 && <StepIndicators step={step} />}
                </div>
            </div>
        </div>
    );
};
